export default __webpack_public_path__ + "static/media/pic1.9f858192.jpg";